import * as React from 'react';
import { Link } from 'react-router-dom';

// If disabling this banner, remove rem-calc(34) for scss variable $error-toast-top inside sass/_errorToast.scss
export default function NewUrlBanner() {
	return <>
		<div className='notification-banner'>
			<div className='message'>
				Configuration Tester now has a new home! Find it at <Link to='/tester'>
					{`${window.location.host}/tester`}
				</Link>.
				You will be automatically redirected there after logging in.
			</div>
		</div>
	</>;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/components/config-studio-index/NewUrlBanner.tsx